import { UserPolice } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Panel } from '..';
import { useCostumeStore, useProjectStore } from '../../../context';
import { Costume, CostumeType, Role, TScriptId } from '@talon/web/lib/api';

export interface IProjectCostumePanelProps {
  scriptId?: TScriptId;
  role: Role;
}

export const ProjectCostumePanel = observer(({ scriptId, role }: IProjectCostumePanelProps) => {
  const [costumes, setCostumes] = useState<Costume[]>([]);
  const projectStore = useProjectStore();
  const costumeStore = useCostumeStore();

  useEffect(() => {
    if (!role) return;
    const getCostumes = async () => {
      const costumes = await costumeStore.getCostumesByRoleId(role.id);
      costumes && setCostumes(costumes);
    };
    getCostumes();
  }, [role]);

  const newCostume = async () => {
    if (!projectStore.currentProject?.id) return;
    const costumeRequest = {
      name: 'New Costume',
      type: CostumeType.Standard,
      scriptIds: scriptId ? [scriptId] : [],
      projectId: projectStore.currentProject.id,
      ownerId: role.id,
    };
    const costume = await costumeStore.createCostume(costumeRequest);
    costumes && costume && setCostumes([...costumes, costume]);
    costume && role.costumes?.push(costume);
  };

  const deleteCostumes = async (ids: string[]) => {
    ids.forEach(async (id) => await costumeStore.deleteCostume(id));
    setCostumes(costumes.filter((r) => !ids.includes(r.id)));
    role.costumes = role.costumes?.filter((r) => !ids.includes(r.id));
  };

  const updateCostume = async (update: Costume, index: number) => {
    const costume = await costumeStore.updateCostume(update);
    if (!costume) return;
    const newCostumes = [...costumes];
    newCostumes[index] = costume;
    setCostumes(newCostumes);
    role.costumes = role.costumes?.map((r) => (r.id === costume.id ? costume : r));
  };

  return (
    <Panel
      items={costumes}
      newItem={newCostume}
      deleteItems={deleteCostumes}
      updateItem={updateCostume}
      label="Costume"
      labelPlural="Costumes"
      addIcon={<UserPolice />}
      types={[
        {
          label: 'Costume Type',
          key: 'type',
          values: Object.values(CostumeType),
        },
      ]}
    />
  );
});
